import React, { useState, useEffect } from 'react';
import { ArrowUpRight, Eye } from 'lucide-react';
import {useNavigate} from 'react-router-dom'

 const OurIdentity = ()=> {
  const [isVisible, setIsVisible] = useState(false);
  const [activeTab, setActiveTab] = useState('vision');
  const navigate = useNavigate();

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const tabs = [
     {
      id: 'mission',
      label: 'Our Mission',
      icon: '🎯',
      title: 'Our Mission',
      content: 'To deliver structured and reliable technology solutions that enhance operational efficiency, strengthen digital capabilities, and support organizations in achieving measurable and sustainable business outcomes.'
    },
    {
      id: 'vision',
      label: 'Our Vision',
      icon: '👁️',
      title: 'Our Vision',
      content: ' To be recognized as a trusted technology partner known for enabling scalable growth, driving innovation through clarity, and delivering consistent value across evolving business environments.'
    },
    {
      id: 'commitment',
      label: 'Our Commitment',
      icon: '🤝',
      title: 'Our Commitment',
      content: '“ To maintain a disciplined approach in every engagement — ensuring precision in execution, transparency in collaboration, and a continuous focus on delivering outcomes that align with long-term business objectives.”'
    }
  ];

  return (
    <div className=" bg-gradient-to-br from-slate-50 to-slate-100 py-20 px-6 md:px-8 lg:px-12">
      <div className="container mx-auto max-w-7xl">
        {/* Top Section */}
        <div className="grid lg:grid-cols-2 gap-8 md:gap-16 mb-8 md:mb-16">
          {/* Left Content */}
          <div className="space-y-4 md:space-y-8">
            {/* Badge */}
         <div className="flex justify-center lg:justify-start">
  <div 
    className={`inline-flex justify-center items-center gap-2 px-6 py-3 border-2 border-slate-900 rounded-full transition-all duration-1000 ${
      isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'
    }`}
  >
    <div className="w-2 h-2 bg-slate-900 rounded-sm"></div>
    <span className="text-slate-900 font-medium">Our Identity</span>
  </div>
</div>


            {/* Heading */}
            <div className="space-y-2 text-center lg:text-start ">
              <h2 
                className={`text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 inline leading-tight transition-all duration-1000 delay-200 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
              >
                Building <span className="italic">Confidence</span>
              </h2>
              <h3 
                className={` flex md:justify-center lg:justify-start  text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 leading-tight transition-all duration-1000 delay-300 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
              >
                Through Innovative <span className='hidden md:flex lg:hidden text-center'>IT Solutions.</span>
              </h3>
              <h3 
                className={`md:hidden lg:flex text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 leading-tight transition-all duration-1000 delay-400 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
              >
                IT Solutions.
              </h3>
            </div>
          </div>

          {/* Right Content */}
          <div className="space-y-8 flex flex-col justify-center">
            <p 
              className={`text-slate-600 text-justify md:text-lg leading-relaxed transition-all duration-1000 delay-600 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              Quantrovia partners with forward-looking organizations to deliver structured technology solutions that strengthen operations, support scalability, and enable long-term business progression through disciplined execution and strategic alignment.
            </p>

            {/* Buttons */}
            <div 
              className={`flex md:flex-wrap gap-4 transition-all duration-1000 delay-800 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              <button 
              onClick={()=>{
                navigate("/about");
                window.scrollTo({
                  top : 0,
                  behavior : "smooth"
                });
              }}
              className="px-8 py-4 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-xl font-medium hover:from-purple-700 hover:to-blue-700 flex items-center gap-2 transition-all duration-300 hover:scale-105 hover:shadow-2xl">
                Learn More <span className='hidden md:flex'>About Us</span> 
              </button>
              <button 
               onClick={()=>{
                navigate("/about");
                window.scrollTo({
                  top : 0,
                  behavior : "smooth"
                });
              }}
              className="group px-8 py-4 bg-slate-900 text-white rounded-xl font-medium hover:bg-slate-800 transition-all duration-300 hover:scale-105 hover:shadow-2xl flex items-center gap-3">
                Get In Touch
                <ArrowUpRight className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Section - Tabbed Content */}
        <div 
          className={`transition-all duration-1000 delay-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
        >
          <div className="grid lg:grid-cols-12 gap-8">
            {/* Left Tabs */}
            <div className="lg:col-span-3">
            <div className="bg-white border-2 border-slate-200 rounded-3xl p-4 sm:p-6 lg:p-8 space-y-2 sm:space-y-3">
    {tabs.map((tab) => (
      <button
        key={tab.id}
        onClick={() => setActiveTab(tab.id)}
        className={`w-full text-left px-4 sm:px-6 py-3 sm:py-4 rounded-xl font-semibold transition-all duration-300 flex items-center gap-3 ${
          activeTab === tab.id
            ? 'text-slate-900 bg-slate-50'
            : 'text-slate-400 hover:text-slate-600 hover:bg-slate-50'
        }`}
      >
        <div className="w-2 h-2 bg-slate-900 rounded-sm shrink-0"></div>
        {tab.label}
      </button>
    ))}
  </div>
</div>

            {/* Right Content */}
           <div className="lg:col-span-9">
  <div className="bg-slate-900 rounded-3xl p-6 sm:p-8 md:p-10 lg:p-12 min-h-[260px] relative overflow-hidden">

                {/* Decorative elements */}
                <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl"></div>
                <div className="absolute bottom-0 left-0 w-64 h-64 bg-purple-500/10 rounded-full blur-3xl"></div>

                {/* Content */}
                <div className="relative z-10">
                  {tabs.map((tab) => (
                    <div
                      key={tab.id}
                      className={`transition-all duration-500 ${
                        activeTab === tab.id
                          ? 'opacity-100 translate-x-0'
                          : 'opacity-0 absolute translate-x-8 pointer-events-none'
                      }`}
                    >
                      <div className="flex flex-col sm:flex-row items-start gap-6 sm:gap-8">
                        {/* Icon */}
                        <div className="flex-shrink-0">
                          <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white rounded-2xl flex items-center justify-center shadow-lg">
                            <svg className="w-8 h-8 sm:w-10 sm:h-10 text-slate-900" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              {tab.id === 'vision' && (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                              )}
                              {tab.id === 'commitment' && (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                              )}
                              {tab.id === 'mission' && (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                              )}
                            </svg>
                          </div>
                        </div>

                        {/* Text Content */}
                       <div className="flex-1 space-y-4 sm:space-y-6">
  <h3 className="text-2xl sm:text-3xl font-bold text-white">
    {tab.title}
  </h3>

  <div className="w-12 sm:w-16 h-px bg-gradient-to-r from-purple-500 to-blue-500"></div>

  <p className="text-slate-300 text-base sm:text-lg leading-relaxed">
    {tab.content}
  </p>
</div>

                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurIdentity;